import {drawer} from '@cypro/ui/components'
import {LogDrawer} from './log-drawer'
import {EventLog} from '@cypro/engine/schema'
import {Suspense} from 'react'
import {EventLogProvider} from '@/shared/contexts/event-log'

export function getLogDrawerId(logId: string) {
  return `log-drawer-${logId}`
}

export function openLogDrawer(log: EventLog) {
  const id = getLogDrawerId(log.id)

  try {
    drawer.remove(id)
  } catch {}

  return drawer.open(id, {
    id,
    children: (
      <Suspense>
        {log && (
          <EventLogProvider log={log}>
            <LogDrawer />
          </EventLogProvider>
        )}
      </Suspense>
    ),
    contentProps: {
      'data-e2e': 'log-drawer',
    },
  })
}
